export default "__VITE_ASSET__nyY2F1q9__"